import { Component, OnInit, Input, Output, EventEmitter, ViewContainerRef } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { environment } from 'environments/environment';
import {
  ValidationUtilService,
  CommonUtilty,
  InteractService,
  AppMetadataHandler,
  CountryCityService
} from 'app'
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ClientAddressDO } from 'app/BaseFramework/shared/models'


@Component({
  selector: 'ui-address-ind',
  templateUrl: './ui-address-ind.component.html',
  styleUrls: ['./ui-address-ind.component.scss']
})
export class UIAddressIndComponent implements OnInit {
  _currentComponentName = 'UIAddressIndComponent'
  constructor(private viewContainerRef: ViewContainerRef,
    private message: NzMessageService,
    public validationUtilService: ValidationUtilService,
    private fb: UntypedFormBuilder,
    private commonUtilty: CommonUtilty,
    private interactService: InteractService,
    public appMetadataHandler: AppMetadataHandler,
    private countryCityService: CountryCityService) { }

  //Declaraions which might need developer input
  uiAddressIndForm: UntypedFormGroup
  UIADDRESSINDFORMNAME = "uiAddressIndForm"
  lookupsToBind = ['cityCd', 'stateCd', 'countryCd', 'addressTypeCd']
  selectorOfThisComponent = 'ui-address-ind'
  parentEvent$
  addressList: Array<any> = [];
  item
  list = [
    1, 2, 3
  ]

  /**
   *
   *  Ninad: Whenever any developer is creating a new Component,
   * please make sure that you copy all import commands, constructor and
   * Boiler and Component Creation Kickstart CODE 
   *
   * 
   * Component Creation Kickstart CODE 
   */
  // emit data to add new hospital 
  @Output() sendAddressedtoSearchAddHospitalComp = new EventEmitter<any>();

  //ComponentSpecific Inputs, Outputs
  @Output() componentOutput = new EventEmitter<any>();
  @Input() type: string;
  @Input() defaultTypeCd: string;
  @Input() viewType: boolean;
  // getting address data from hospital and doctor comp
  @Input() getHospitalAddressData: any;
  // for hospitalization make type default
  @Input() removeAddressType: boolean;

  private _inputDataForEdit = null;
  @Input()
  set inputDataForEdit(value: any) {
    if (value) this._inputDataForEdit = value;
  };

  private _disableDefaultCountryOnly: boolean = false;
  @Input()
  set disableDefaultCountryOnly(value: any) {
    if (value == null || value == undefined)
      this._disableDefaultCountryOnly = false
    else
      this._disableDefaultCountryOnly = value

  }

  get disableDefaultCountryOnly() {
    return this._disableDefaultCountryOnly
  }

  EmitComponentOutput(data) {
  }
  getParentComponent(): Component {
    try { return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component } catch { };
  }
  getParentComponentName(): string {
    try { return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component.constructor.name } catch { };
  }
  getCurrentComponentName(): string {
    return this._currentComponentName
  }

  subscribeToParentEvent() {
    if (this.parentEvent$ != null)
      this.parentEvent$.unsubscribe()
    this.parentEvent$ = this.interactService.pingSubject$.subscribe(() => {
      let validationResult = this.validationUtilService.validateOutput(this.uiAddressIndForm, this.UIADDRESSINDFORMNAME, this.getCurrentComponentName())
      if (!validationResult.isInvalid)
        this.EmitComponentOutput(this.uiAddressIndForm)
      else {
        this.EmitComponentOutput("ERROR")
      }
    })
  }

  //Initializations
  lookup$: any = this.commonUtilty.initializeLookupList(this.lookupsToBind)
  cityCd$: any = this.countryCityService.getProvinceCities(null)
  provinceCd$: any = this.countryCityService.getListOfProvincesForCountry(null)
  provinceSelected() {
    this.uiAddressIndForm.controls['cityCd'].setValue(undefined)
    this.cityCd$ = this.countryCityService.getProvinceCities(this.uiAddressIndForm.get('stateCd').value)
  }

  countrySelected() {
    this.uiAddressIndForm.controls['stateCd'].setValue(undefined)
    this.uiAddressIndForm.controls['cityCd'].setValue(undefined)
    this.provinceCd$ = this.countryCityService.getListOfProvincesForCountry(this.uiAddressIndForm.get('countryCd').value)
  }

  fetchProvinceandCityByPostCode() {
    this.message.loading('Searching . . .', { nzDuration: 1000 });
    this.countryCityService.getPostCodeProvince(this.uiAddressIndForm.get('postCode').value).
      subscribe(resp => {
        if (resp && Array.isArray(resp) && resp.length > 0) {
          this.uiAddressIndForm.controls['stateCd'].setValue(resp[0].stateCd);
          this.uiAddressIndForm.controls['cityCd'].setValue(resp[0].cityCd);
          this.uiAddressIndForm.controls['countryCd'].setValue(resp[0]['countryCd']);
          
        }else
        this.message.warning("No Result found for entered Pincode/Postcode.")
      });
  }

  ngOnInit() {
    const consoleStyle = 'color: red; padding: 2px 5px; border-radius: 2px'
    if (environment && !environment.production) {
      console.group('%cClaims Basic Details : Usage detected on ' + this.getParentComponentName(), 'color: white; background-color: orange; padding: 2px 5px; border-radius: 2px');
      console.log(`%c<${this.selectorOfThisComponent}></${this.selectorOfThisComponent}>, has been used. `, consoleStyle)
      console.log("%cYou can override default title, message and icon(ng-zorro icon name).", consoleStyle)
      console.log(`%cExample , <${this.selectorOfThisComponent} (componentOutput)='doSomethingOnDataReceived()'></${this.selectorOfThisComponent}>`, consoleStyle)
      console.groupEnd();
    }
    this.initializeAddAddressForm(this._inputDataForEdit)
    this.subscribeToParentEvent()
    this.initializeAddressListEditMode()

    if (this.getHospitalAddressData && this.getHospitalAddressData.length) {
      this.addressList = this.getHospitalAddressData;
      this.sendAddressedtoSearchAddHospitalComp.emit(this.addressList);
    }
  }

  initializeAddressListEditMode() {
    if (this._inputDataForEdit) {
      this.addressList = this._inputDataForEdit;
    }
  }

  /**
   * Form Trasactions
   */

  initializeAddAddressForm(data?, isEdit?, index?) {
    let payload = data || {}
    let countryCd
    if (!this.disableDefaultCountryOnly){
      countryCd = this.appMetadataHandler.currentCountryCd
      if(this.appMetadataHandler.featureFlags.BSLI_Config) countryCd = this.appMetadataHandler.currentCountryName;
   } else
      countryCd = payload['countryCd']
    this.uiAddressIndForm = this.fb.group({
      addressLine1: this.validationUtilService.setValidationsForFormControl('addressLine1', this.UIADDRESSINDFORMNAME, payload['addressLine1']),
      addressLine2: this.validationUtilService.setValidationsForFormControl('addressLine2', this.UIADDRESSINDFORMNAME, payload['addressLine2']),
      addressLine3: this.validationUtilService.setValidationsForFormControl('addressLine3', this.UIADDRESSINDFORMNAME, payload['addressLine3']),
      cityCd: this.validationUtilService.setValidationsForFormControl('cityCd', this.UIADDRESSINDFORMNAME, payload['cityCd']),
      postCode: this.validationUtilService.setValidationsForFormControl('postCode', this.UIADDRESSINDFORMNAME, payload['postCode']),
      isEdit: this.validationUtilService.setValidationsForFormControl('isEdit', this.UIADDRESSINDFORMNAME, isEdit),
      index: this.validationUtilService.setValidationsForFormControl('index', this.UIADDRESSINDFORMNAME, index),
      stateCd: this.validationUtilService.setValidationsForFormControl('stateCd', this.UIADDRESSINDFORMNAME, payload['stateCd']),
      countryCd: this.validationUtilService.setValidationsForFormControl('countryCd', this.UIADDRESSINDFORMNAME, countryCd),
      typeCd: this.validationUtilService.setValidationsForFormControl('typeCd', this.UIADDRESSINDFORMNAME, payload['typeCd']),
      id: this.validationUtilService.setValidationsForFormControl('id', this.UIADDRESSINDFORMNAME, payload['id']),
      prefferedFl: this.validationUtilService.setValidationsForFormControl('prefferedFl', this.UIADDRESSINDFORMNAME, payload['prefferedFl']),
      enableSearchByPinCode: this.validationUtilService.setValidationsForFormControl('enableSearchByPinCode', this.UIADDRESSINDFORMNAME)
    });

    if(this.appMetadataHandler.featureFlags.BSLI_Config)
      this.uiAddressIndForm.controls['enableSearchByPinCode'].setValue(true);
      // this.uiAddressIndForm.controls['typeCd'].setValue(this.defaultTypeCd)
  }

  addAddress() {
    if (this.uiAddressIndForm.status === 'VALID') {
      let addressDO = new ClientAddressDO();
      if (this.uiAddressIndForm.value.isEdit) {
        addressDO = this.addressList[this.uiAddressIndForm.value.index];
      }
      addressDO.typeCd = this.uiAddressIndForm.value.typeCd,
      addressDO.addressLine1 = this.uiAddressIndForm.value.addressLine1;
      addressDO.addressLine2 = this.uiAddressIndForm.value.addressLine2;
      addressDO.addressLine3 = this.uiAddressIndForm.value.addressLine3;
      addressDO.stateCd = this.uiAddressIndForm.value.stateCd;
      addressDO.countryCd = this.uiAddressIndForm.value.countryCd;
      addressDO.postCode = this.uiAddressIndForm.value.postCode;
      addressDO.cityCd = this.uiAddressIndForm.value.cityCd;
      addressDO.id = this.uiAddressIndForm.value.id;
      addressDO.prefferedFl = this.uiAddressIndForm.value.prefferedFl;

      if (this.uiAddressIndForm.value.isEdit) {
        this.addressList.splice(this.uiAddressIndForm.value.index, 1, this.commonUtilty.deepCopy(addressDO))
      } else {
        this.addressList.push(this.commonUtilty.deepCopy(addressDO));
      }

      if (this.commonUtilty.isArrayIterable(this.addressList))
        this.addressList[0]['prefferedFl'] = true;

      this.EmitComponentOutput(this.addressList)
      this.initializeAddAddressForm()
    } else {
      this.validationUtilService.validateOutput(this.uiAddressIndForm, this.UIADDRESSINDFORMNAME, this.getCurrentComponentName());
      this.initializeAddAddressForm()
      this.uiAddressIndForm.markAllAsTouched();
    }
    this.sendAddressedtoSearchAddHospitalComp.emit(this.addressList);
  }

  editAddress(address, index) {
    let isEdit = true;
    this.initializeAddAddressForm(address, isEdit, index)
    this.cityCd$ = this.countryCityService.getProvinceCities(this.uiAddressIndForm.get('stateCd').value)
  }

  removeAddress(index) {
    this.addressList.splice(index, 1)
    this.EmitComponentOutput(this.addressList)
  }

  clearForm() {
    this.initializeAddAddressForm()
  }

  enableSearchByPinCode
  enableDisableSearchByPin() {
    this.clearPinStateCity()
  }

  clearPinStateCity() {
    const fieldToNullify = ['postCode', 'stateCd', 'cityCd']
    fieldToNullify.forEach(e => this.uiAddressIndForm.controls[e].setValue(null))
  }

  deselectOtherAddresssesPrefferedFl(priIndex) {
    this.addressList.forEach((element, index) => {
      if (priIndex != index) element.prefferedFl = false
    });
  }

  FormFieldNameMap = {
    firstName: "First Name",
    lastName: "Last Name",
  }
}
